import database from "../../../services/database";
import IconButton from "../../../components/icon-button";
import React from "react";
import SEO from "../../../components/SEO";

function Home() {
    return (
        <>
            <SEO 
                title="Médico-Hospitalar"
                description="Produtos médico-hospitalares: cadeiras de rodas, scooters, andadores, home care, infralux e muito mais. Assistência técnica especializada."
                keywords="cadeira de rodas, scooter, andador, home care, infralux, produtos hospitalares, equipamentos médicos"
                canonicalUrl="https://www.saojoseortopedicos.com.br/produtos/medico-hospitalar"
            />
            <h2>{database.medico_hospitalar.title}</h2>
            {
                <ul className="icones">
                    {
                        database.medico_hospitalar.items.map(y => {
                            return (
                                <li>
                                    <IconButton
                                        title={y.title}
                                        icon={y.icon}
                                        path={y.path}
                                        iconLegend={y.iconLegend}
                                    />
                                </li>
                            );
                        })
                    }
                </ul>
            }
        </>
    );
}

export default Home;